export default function getIsApp() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const channel = urlParams.get("channel");
  return channel === "app";
}
